import React, { useState, useEffect } from "react";
import Card from "../components/card/Card.jsx";
import nft from "../assets/img/nft.png";
import nft2 from "../assets/img/nft2.png";
import topleft from "../assets/img/topleft.png";
import Footer from "../components/footer/Footer.jsx";
import { useHistory } from "react-router";

export default function Discovery() {
  const history = useHistory();

  const newlyAdded = [
    { type: "bid", image: nft },
    { type: "bid", image: nft2 },
    { type: "direct", image: nft },
    { type: "bid", image: nft },
    { type: "bid", image: nft2 },
    { type: "direct", image: nft },
    { type: "bid", image: nft },
    { type: "bid", image: nft2 },
    { type: "direct", image: nft },
  ];

  return (
    <div style={{ paddingTop: "100px" }} className="discover-wrapper">
      <div className="price" style={{ marginTop: "-14px", fontSize: "12px" }}>
        <div>
          <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
          <div> 1 BNB = $USD 0.452 </div>
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-header">Newly Added</div>
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/nftdetails",
                    state: { type: item.type },
                  })
                }
              >
                <Card image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-header">Popular</div>
        <div className="first-row">
          {newlyAdded.map((item, i) => {
            return (
              <div
                key={i}
                className="each-card"
                onClick={() =>
                  history.push({
                    pathname: "/nftdetails",
                    state: { type: item.type },
                  })
                }
              >
                <Card image={item.image} type={item.type} />
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}
